import React, { useState, useEffect, useContext } from "react";
import EventBusyRoundedIcon from "@mui/icons-material/EventBusyRounded";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getCreditosPorVencerAsync } from "../../../api/Dashboard";
import KpiCard from "../../../components/ui/KpiCard";

const CreditosPorVencer = ({ selectedSucursal }) => {
  const [creditosPorVencer, setCreditosPorVencer] = useState(0);
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getCreditosPorVencerAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setCreditosPorVencer(result.data.result);
    })();
  }, [selectedSucursal]);

  return (
    <KpiCard
      onClick={() => navigate(`${ruta}/credits`)}
      icon={<EventBusyRoundedIcon sx={{ fontSize: 20 }} />}
      iconBg="warning.light"
      iconColor="warning.main"
      value={creditosPorVencer}
      label="Créditos por vencer (7 días)"
    />
  );
};

export default CreditosPorVencer;
